import { StringFindRequest } from "../../../core/type"

export interface UserFindRequest {
  id?: number
  name?: string
  hasContact?: boolean
  role?: StringFindRequest
}

export enum UserRole {
  Admin = 'Admin',
  Customer = 'Customer',
  Appraiser = 'Appraiser',
}